export default __webpack_public_path__ + "static/media/coinshop.89af411e.png";